import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";

function Contact() {
  return (
    <Box id="contact" sx={{ py: 8 }}>
      <Container sx={{ textAlign: "center" }}>
        <Typography variant="h4" gutterBottom>Contact</Typography>
        <Typography>📞 7989842401</Typography>
        <Typography>📧 mohankrishnamadanapu@gmail.com</Typography>
        <Typography sx={{ mt: 1 }}>
          🔗 LinkedIn:{" "}
          <a
            href="https://www.linkedin.com/in/mohankrishnamadanapu29546b1b3/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#52B2BF", fontWeight: "bold", textDecoration: "none" }}
          >
            Visit My LinkedIn
          </a>
        </Typography>
        {/* <Typography sx={{ mt: 1 }}>
          💻 GitHub:{" "}
          <a
            href="https://github.com/yourgithub"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#52B2BF", fontWeight: "bold", textDecoration: "none" }}
          >
            View My GitHub
          </a>
        </Typography> */}
        <Button
          variant="outlined"
          color="primary"
          href="mailto:mohankrishnamadanapu@gmail.com"
          sx={{ mt: 3 }}
        >
          Send Email
        </Button>
      </Container>
    </Box>
  );
}

export default Contact;
